import React from 'react';
import AppRoute from '../frames/AppRoute';
import Login from '../pages/Login';
import SignUp from '../pages/SignUp';
import Welcome, { SlideInfo } from '../pages/Welcome';
import SharedRoutePath from '../SharedRoutePath';
import ExternalReturn from '../pages/External-Return';
/**
 * Provides the common AppRoutes for all the apps. To be placed inside a Route Element.
 * @param welcomeSlides - array of SlideInfo objects with details of what to
 * show on the welcome slides
 * @returns an array of JSX AppRoute elements
 */
export default function CommonAppRoutes(
  welcomeSlides: SlideInfo[]
): JSX.Element[] {
  return [
    <AppRoute
      key="welcome"
      publicRoute
      path={SharedRoutePath.WELCOME}
      display={<Welcome slides={welcomeSlides} />}
      edgeToEdge
      fullScreen
    />,
    <AppRoute
      key="login"
      publicRoute
      path={SharedRoutePath.LOGIN}
      display={<Login />}
      fullScreen
      centerContent
    />,
    <AppRoute
      key="sign-up"
      publicRoute
      path={SharedRoutePath.SIGN_UP}
      display={<SignUp />}
      fullScreen
      centerContent
    />,

    <AppRoute
      key="external-return"
      publicRoute
      path={SharedRoutePath.EXTERNAL_RETURN}
      display={<ExternalReturn />}
      fullScreen
      centerContent
    />,
  ];
}
